import { onCleanup } from "solid-js";

export function clickOutsideEvent$(el: Element, accessor: () => any) {
  const onClick = (e) => !el.contains(e.target) && accessor()?.();
  document.body.addEventListener("click", onClick);

  onCleanup(() => document.body.removeEventListener("click", onClick));
}
